//export const API_URL = "https://demo-printing.5techg.com/api/";
//export const API_URL = "http://localhost:3002/api/";
// export const API_URL = "http://localhost:4001/api/";
// export const API_URL = "https://imprint24.5techg.com/api/";
// export const API_URL = "https://imprint24.5techg.com/api/";
export const API_URL = "https://api-imprint.5techg.com/api/";
